export default {
	EMPLOYEE_LOGIN_REQUEST_START: 'EMPLOYEE_LOGIN_REQUEST_START',
	EMPLOYEE_LOGIN_REQUEST_SUCCESS: 'EMPLOYEE_LOGIN_REQUEST_SUCCESS',
	EMPLOYEE_LOGIN_REQUEST_ERROR: 'EMPLOYEE_LOGIN_REQUEST_ERROR'
};
